export const getTrendLine = (data) => {
    const n = data.length;

    let sumX = 0,
        sumY = 0,
        sumXY = 0,
        sumX2 = 0;

    // Calculate the sums needed for linear regression
    for (let i = 0; i < n; i++) {
        const [x, y] = data[i];
        sumX += x;
        sumY += y;
        sumXY += x * y;
        sumX2 += x ** 2;
    }

    // Calculate the slope of the trend line
    const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX ** 2);

    // Calculate the intercept of the trend line
    const intercept = (sumY - slope * sumX) / n;

    const trendline = []; // Array to store the trend line data points

    // Find the minimum and maximum x-values from the scatter plot data
    let minX = Math.min(...data.map(([x]) => x));
    let maxX = Math.max(...data.map(([x]) => x));

    // Calculate the corresponding y-values for the trend line using the slope
    // and intercept
    trendline.push([minX, minX * slope + intercept]);
    trendline.push([maxX, maxX * slope + intercept]);

    return trendline;
}


export const getTrendData = (HoursGraphsData,ykey,xkey) => {
    let data = HoursGraphsData;
    let trendData = [];

    if (Array.isArray(data)) {
        data.forEach(obj => {
            let dateOfService = obj[xkey];
            let y = obj[ykey]
            let dateObj = new Date(dateOfService);
            let year = dateObj.getFullYear();
            let month = dateObj.getMonth();
            let date = dateObj.getUTCDate();
            let secondArry = [];
            secondArry.push(Date.UTC(year,month,date));
            // secondArry.push(dateObj);
            secondArry.push(y);
            trendData.push(secondArry);
        })
    } else {
        console.log("please provide array data");
    }
    return trendData;
}


export const getAverageLine = (HoursGraphsData) => {
    const data = HoursGraphsData;

    // console.log("HoursGraphsData -->",data)
    let averageLine = [];
    if (Array.isArray(data) && data.length) {
        const sum = data.reduce((acc, [, y]) => acc + y, 0);
        let average = sum / data.length;
        average = average.toFixed(2);
        averageLine = data.map(d=>{
            return [d[0],parseFloat(average)]
        })
        // averageLine = [[data[0][0].getTime(), average], [data[data.length - 1][0].getTime(), average]]
    }

       
    return averageLine;
}



// WEBPACK FOOTER //
// ./src/chartUtils/utlis.js